export const AgentTextClassMap = {
  edggy: "text-gradient-agent",
  sentiment: "text-gradient-agent-3",
  macro: "text-gradient-agent-2",
  sector: "text-gradient-agent-1",
  "360": "text-gradient-agent-4",
  default: "text-gradient-agent-5",
};
